import { put, takeEvery, call } from 'redux-saga/effects';
import { AppActions } from './actions';
import ApiService from '../../../Services/ApiService';

export function* fetchUseCases() {
  try {
    const useCases = yield call(ApiService.getUseCases);
    yield put(AppActions.fetchUseCasesSucceeded(useCases));
  } catch (e) {
    yield put(AppActions.fetchUseCasesFailed(e.response.data));
  }
}

export function* enableTeamManagement() {
  try {
    yield call(ApiService.enableTeamManagement);
    yield put(AppActions.enableTeamManagementSucceeded());
  } catch (e) {
    yield put(AppActions.enableTeamManagementFailed(e.response.data));
  }
}

export function* disableTeamManagement() {
  try {
    yield call(ApiService.disableTeamManagement);
    yield put(AppActions.disableTeamManagementSucceeded());
  } catch (e) {
    yield put(AppActions.disableTeamManagementFailed(e.response.data));
  }
}

export function* eventTracking(action) {
  try {
    yield call(ApiService.eventTracking, action.payload);
    yield put(AppActions.eventTrackingSucceeded());
  } catch (e) {
    yield put(AppActions.eventTrackingFailed(e.response.data));
  }
}

export function* watchApp() {
  yield takeEvery(AppActions.fetchUseCases, fetchUseCases);
  yield takeEvery(AppActions.enableTeamManagement, enableTeamManagement);
  yield takeEvery(AppActions.disableTeamManagement, disableTeamManagement);
  yield takeEvery(AppActions.eventTracking, eventTracking);
}
